// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3swtr","video":"styles_video__W1bxI","videoHolder":"styles_videoHolder__2cLtF"};